import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
	const { rightSectionProps } = state.rootReducer.testPageDetails;

	return {
		rightSectionProps,
	};
};

const PassageFill = ({ rightSectionProps: { clozeQuestion } }) => {
	const [clozeQ, setClozeQ] = useState('');

	useEffect(() => {
		if (!!clozeQuestion) {
			let clozeQ = clozeQuestion.replace(
				/\[blank\]/g,
				`<span class="to-be-filled"></span>`,
			);
			setClozeQ(clozeQ);
		}
	}, [clozeQuestion]);

	return (
		<p
			className="converse-pasage text-2x"
			dangerouslySetInnerHTML={{ __html: clozeQ }}
		/>
	);
};

export default connect(mapStateToProps)(PassageFill);
